import Select, { type GroupBase, type MenuPlacement, type StylesConfig } from "react-select";
import type { ReactNode } from "react";

interface SelectMenuProps<TOption extends object> {
  error?: string;
  handleInputChange: (event: { target: { name: string; value: TOption | null } }) => void;
  menuPlacement?: MenuPlacement;
  name: string;
  options?: readonly TOption[];
  defaultValue?: TOption | readonly TOption[] | null;
  isMulti?: boolean;
  title?: ReactNode;
  value?: TOption | readonly TOption[] | null;
  isClearable?: boolean;
  disabled?: boolean;
  parentClass?: string;
  placeholder?: string;
}

export default function SelectMenu<TOption extends object>(props: SelectMenuProps<TOption>) {
  const {
    error,
    handleInputChange,
    menuPlacement,
    name,
    options,
    defaultValue,
    isMulti,
    title,
    value,
    isClearable,
    disabled,
    parentClass,
    placeholder,
  } = props;

  const customStyles: StylesConfig<TOption, boolean, GroupBase<TOption>> = {
    control: (base) => ({
      ...base,
      minHeight: 34,
      fontSize: 15,
      paddingTop: 0,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div className={parentClass}>
      {title ? (
        <div className="mb-2">
          <label htmlFor="type" className="block text-sm font-medium text-gray-900">
            {title}
          </label>
        </div>
      ) : null}
      <div>
        <Select<TOption, boolean>
          isMulti={isMulti}
          name={name}
          options={options}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          menuPlacement={menuPlacement}
          noOptionsMessage={() => `Choose a ${title}`}
          onChange={(val: TOption | readonly TOption[] | null) => {
            handleInputChange({ target: { name, value: val as TOption | null } });
          }}
          styles={customStyles}
          // styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          menuPortalTarget={document.body}
          isClearable={isClearable}
          isDisabled={disabled}
        />
        {error ? <p className="font-medium text-red-500 mt-1 text-sm">{error}</p> : null}
      </div>
    </div>
  );
}
